<template>
 <div class="w-full h-full custom-content-publi" :class="{ 'mt-0': isDesktop }">
    <div class="notebook">
      <div class="lock">
        <template v-if="!canDisplayOnMobileIOS">
          <div class="title-banner free">{{ $t('PRIVATE_CONTENT').Exclusive_Subscribers }}</div>
          <div class="subtitle-banner demo">{{ $t('PRIVATE_CONTENT').Sign_Up_access }}</div>
          <vs-button class="btn-register-lock" @click.stop="$emit('open-my-account')">{{ $t('PRIVATE_CONTENTUSERDEMO').Register }}</vs-button>
        </template>
        <template v-else>
          <div class="title-banner free">{{ $t('PRIVATE_CONTENT').Exclusive_Subscribers }}</div>
          <div class="subtitle-banner free">{{ $t('PRIVATE_CONTENTUSERDEMO').IOS_Text }}</div>
          <vs-button class="btn-register-lock" @click.stop="$emit('open-attendance')">{{ $t('PRIVATE_CONTENTUSERDEMO').Attendance }}</vs-button>
        </template>
      </div>
    </div>
    <div class="smart">
      <ul class="smartContent">
        <h2 class="mb-5 title-ben">{{ $t('PRIVATE_CONTENT').Smart_Content_Title }}</h2>
        <li>🔎 {{ $t('PRIVATE_CONTENT').Smart_Content_L1 }}</li>
        <li>💰 {{ $t('PRIVATE_CONTENT').Smart_Content_L2 }}</li>
        <li>📊 {{ $t('PRIVATE_CONTENT').Smart_Content_L3 }}</li>
        <li>🌎 {{ $t('PRIVATE_CONTENT').Smart_Content_L4 }}</li>
        <li>📈 {{ $t('PRIVATE_CONTENT').Smart_Content_L5 }}</li>
      </ul>
      <div class="alert-span">{{ $t('PRIVATE_CONTENT').Alert_Footer }}</div>
    </div>
  </div>
</template>



<script>
import userService from '../../../providers/userService';
import { getCodeLang } from '../../../helpers/locale-helper';
import messageDialogHelper from '../../../helpers/message-dialog-helper';
import localStorageHelper from '../../../helpers/local-storage-helper';
import biometryHelper from '../../../helpers/biometry-helper';

export default {
  props: {
    isDesktop: {
      require: true
    },
    displayCloseBtn: {
    default: true
    },
  },
  data() {
    return {
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.3,
          swipeEasing: true
      },
      requestingDemo: false
    };
  },
  watch: {
  },
  computed: {
    canDisplayOnMobileIOS() {
      return this.$store.state.isMobileIOS;
    },
    contentPrivate() {
      return this.$store.state.contentPrivate || {text: ''};
    },
    featherIconSize() {
      if (this.isDesktop) {
        return "h-8 w-8";
      } else {
        return "h-6 w-6";
      }
    },
    safrasSiteEn() {
      return this.$t('GENERAL').Safras_Url_Request;
    },
    safrasSiteEs() {
      return this.$t('GENERAL').Safras_Url_Request;
    },
    safrasSiteAr() {
      return this.$t('GENERAL').Safras_Url_Request;
    },
  },
  methods: {
    requestDemo() {
      if (this.currentLocale() == 'PtBr') {
        userService.requestDemo(new URLSearchParams())
        .then(() => {
          messageDialogHelper.displayDialogAccept(
              this.$t("PRIVATE_CONTENT").Dialog_Title, 
              this.$t("PRIVATE_CONTENT").Demo_Requested,)
          this.displaySentDemoRequestMessage = true;
        })
        .catch(err => console.log(err));
      } else if (this.currentLocale() == 'EnEu') {
        if (this.isDesktop) {
          window.open(this.safrasSiteEn, '_blank');
        } else {
          if (checkDeviceTypeHelper.isReactApp()) {
            biometryHelper.openExternalUrl(this.safrasSiteEn);
          } else {
            cordova.InAppBrowser.open(this.safrasSiteEn, '_system');
          }
        }
      } else if (this.currentLocale() == 'EsEs') {
        if (this.isDesktop) {
          window.open(this.safrasSiteEs, '_blank');
        } else {
          if (checkDeviceTypeHelper.isReactApp()) {
            biometryHelper.openExternalUrl(this.safrasSiteEs);
          } else {
            cordova.InAppBrowser.open(this.safrasSiteEs, '_system');
          }
        }
      } else if (this.currentLocale() == 'PtPt') {
        if (this.isDesktop) {
          window.open(this.safrasSiteEs, '_blank');
        } else {
          if (checkDeviceTypeHelper.isReactApp()) {
            biometryHelper.openExternalUrl(this.safrasSiteEs);
          } else {
            cordova.InAppBrowser.open(this.safrasSiteEs, '_system');
          }
        }
      } else {
        if (this.isDesktop) {
          window.open(this.safrasSiteAr, '_blank');
        } else {
          if (checkDeviceTypeHelper.isReactApp()) {
            biometryHelper.openExternalUrl(this.safrasSiteAr);
          } else {
            cordova.InAppBrowser.open(this.safrasSiteAr, '_system');
          }
        }
      };
    },
    currentLocale() {
      const localeCode = getCodeLang(localStorageHelper.getLocale());
      return localeCode
    },
  }
};

</script>
